import backend from '@/services/backend'
// import store from '@/store'

export default {

    getGroupList (authToken, realmName, studyName) {
        return backend.get('keyingress/groups/' + realmName + '/' + studyName, { headers: { Authorization: authToken }} )
    },

    getActions(authToken, realmName, studyName) {
        return backend.get('keyingress/actions/' + realmName + '/' + studyName, { headers: { Authorization: authToken }} )
    },

    runAction(authToken, realmName, studyName, actionName) {
        return backend.get('keyingress/runaction/' + realmName + '/' + studyName + '/' + actionName, { headers: { Authorization: authToken }} )
    },

    importSamples(authToken, realmName, studyName, targetGroup) {
        return backend.get('keyingress/uiimportsamples/' + realmName + '/' + studyName + '/' + targetGroup, { headers: { Authorization: authToken }} )
    }

}
